/** Whether an object may be included in Select All (SC-CP-03) or marquee multi-select (SC-MX-01). */
export function isObjectEligibleForSelectAll(obj: { locked?: boolean; frozen?: boolean }): boolean {
  return obj.locked !== true && obj.frozen !== true
}

/** True when exactly one selected object is frozen (SC-MX-07: Unfreeze Selected). */
export function isSingleFrozenSelectionForUnfreeze(
  shapes: readonly { frozen?: boolean }[],
  textBoxes: readonly { frozen?: boolean }[]
): boolean {
  const count = shapes.length + textBoxes.length

  if (count !== 1) return false

  return shapes[0]?.frozen === true || textBoxes[0]?.frozen === true
}

/** Strip freeze from clipboard snapshots so pasted copies are never frozen (SC-CP-01/02). */
export function stripFreezeFromClipboardSnapshot<T extends { frozen?: boolean }>(snapshot: T): T {
  return { ...snapshot, frozen: false }
}
